exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#facebox .b{background:url(" + require("./b.png") + ")}#facebox .tl{background:url(" + require("./tl.png") + ")}#facebox .tr{background:url(" + require("./tr.png") + ")}#facebox .bl{background:url(" + require("./bl.png") + ")}#facebox .br{background:url(" + require("./br.png") + ")}#facebox{position:absolute;top:0;left:0;z-index:100;text-align:left}#facebox .popup{position:relative;padding-bottom:40px}#facebox table{border-collapse:collapse}#facebox td{border-bottom:0;padding:0}#facebox .body{padding:10px;background:#fff;width:800px}#facebox .image,#facebox .loading{text-align:center}#facebox img{border:0;margin:0}#facebox .footer{border-top:1px solid #ddd;padding-top:5px;margin-top:10px;text-align:right}#facebox .bl,#facebox .br,#facebox .tl,#facebox .tr{height:10px;width:10px;overflow:hidden;padding:0}#facebox_overlay{position:fixed;top:0;left:0;height:100%;width:100%}.facebox_hide{z-index:-100}.facebox_overlayBG{background-color:#000;z-index:99}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./es6/admin-common-js/legacy/vendor/facebox/facebox.css
// module id = 540
// module chunks = 7 8 9 10